import React from 'react'
import { ContentHeader } from '@app/components'
import IncentiveTable from '@app/components/Tables/IncentiveTable'

function Incentives() {
  return (
    <div>
    <ContentHeader title="Customer Incentives" />
      <IncentiveTable/>
  </div>
  )
}

export default Incentives